module.exports = __webpack_public_path__ + "media/images/iconbox/icon3-9a87d616b19272bd55a8eda18aff1dcb.png";